// extracted by mini-css-extract-plugin
module.exports = {"Orders":"Orders_Orders__2vMvb","Orders__list":"Orders_Orders__list__2f_lc","HistoryCard":"Orders_HistoryCard__1xNg9","HistoryCard__details":"Orders_HistoryCard__details__1_2-k"};